import { useDarkMode } from "@/hooks/useDarkMode";
import XMarkIcon from "@heroicons/react/20/solid/XMarkIcon";
import { CSSProperties, ReactNode, useMemo } from "react";
import { Button } from "./button";
import { MoonIcon, SunIcon } from "lucide-react";
import clsx from "clsx";

export type DialogProps = {
  className?: string
  contentClassName?: string
  actionsClassName?: string
  icon?: ReactNode;
  title?: string | ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  style?: CSSProperties;
  onClose?: () => void;
}

export const Dialog2 = (props: DialogProps) => {
  const [mode, setMode] = useDarkMode();

  const titleBarActions = useMemo(() => {
    return <div className="flex flex-row gap-2 items-center ml-auto">
      <Button
        icon={mode === "dark" ? <SunIcon size={16} /> : <MoonIcon size={16} />}
        onClick={() => {
          setMode(mode === "dark" ? "light" : "dark");
        }}
        className="p-1 rounded-full"
      />
      {props.onClose &&
        <Button
          icon={<XMarkIcon className="w-4 h-4" />}
          className="p-1 rounded-full"
          onClick={props.onClose}
        />
      }
    </div>
  }, [mode, props.onClose, setMode]);

  return (
    <>
      <div
        className={clsx(
          "animate-in animate-out",
          "rounded-md border shadow-md",
          "border-zinc-300 dark:border-zinc-400",
          "bg-white dark:bg-zinc-800 dark:text-white",
          "overflow-hidden",
          "flex flex-col",
          props.className
        )}
        style={props.style}
      >
        {props.title !== undefined &&
          <div className="flex flex-row gap-2 items-center justify-between px-4 pt-2">
            {typeof props.title === "string" ? (
              <div className="flex flex-row gap-2 items-center">
                {props.icon}
                <span className="text-lg">
                  {props.title}
                </span>
              </div>) : <div className="flex flex-row gap-2 items-center">{props.icon} {props.title}</div>
            }
            {titleBarActions}
          </div>
        }
        <div className={clsx("flex flex-col flex-grow flex-shrink gap-4 min-h-0", props.contentClassName)}>
          {!props.title && props.onClose &&
            <>
              {props.icon}
              <div className={clsx("flex flex-row align-center justify-end", props.actionsClassName)}>
                {titleBarActions}
              </div>
            </>
          }
          {props.children}
        </div>
        {props.footer &&
          <div className="flex flex-row-reverse gap-2 p-4 text-black">
            {props.footer}
          </div>
        }
      </div>
    </>
  );
}